var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgApplicationProgress = function SvgApplicationProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5a2.006 2.006 0 00-2 2v14a2.006 2.006 0 002 2h14a2.006 2.006 0 002-2V5a2.006 2.006 0 00-2-2zm0 16H5V5h14zm-8-9h2v7h-2zm4-1h2v8h-2zm-8 4h2v4H7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.041 7L18 10h-4l2.041-3z"
  })));
};
export default SvgApplicationProgress;